<template>
  <div class="tableSonTemp">
    <div
      :style="{
        color: color ? color : '#606266',
      }"
      v-if="data"
    >
      <div class="ellipsisStyle" v-if="type == 'date'">
        <i class="el-icon-date elIcon" />
        <span>{{ data }}</span>
      </div>
      <div class="ellipsisStyle" v-if="type == 'time'">
        <i class="el-icon-time elIcon" />
        <span>{{ data }}</span>
      </div>
      <div class="ellipsisStyle elIcon" v-if="type == 'datetime'">
        <i class="el-icon-watch" />
        <span>{{ data }}</span>
      </div>
    </div>
    <div v-else>-</div>
  </div>
</template>
<script>
export default {
  props: ["data", "config"],
  computed: {
    color() {
      return this.config.rules.baseConfig.color;
    },
    type() {
      return this.config.rules.dateConfig.type;
    },
  },
  methods: {},
};
</script>
